import __request__ from "routing/request";
export function loggers(requestOptions) {
  return __request__("GET", "/cluster/system/loggers", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function messages(nodeId, limit = 1e3, requestOptions) {
  return __request__("GET", `/cluster/system/loggers/messages/recent/${nodeId}`, null, { "limit": limit }, {
    "Accept": ["text/plain"]
  }, requestOptions);
}
export function subsystems(requestOptions) {
  return __request__("GET", "/cluster/system/loggers/subsystems", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function setClusterSingleLoggerLevel(loggerName, level, requestOptions) {
  return __request__("PUT", `/cluster/system/loggers/${loggerName}/level/${level}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function setSubsystemLoggerLevel(nodeId, subsystem, level, requestOptions) {
  return __request__("PUT", `/cluster/system/loggers/${nodeId}/subsystems/${subsystem}/level/${level}`, null, {}, {
    "Accept": []
  }, requestOptions);
}
